import { z } from 'zod'

export const payablesSummarySearchSchema = z.object({
    page: z.coerce.number().default(1),
    recordsPerPage: z.coerce.number().default(10),
    sortBy: z.string().default('billDate'),
    order: z.string().default('desc'),
})

export const reportingSearchSchema = z.object({
    page: z.coerce.number().default(1),
    recordsPerPage: z.coerce.number().default(10),
    sortBy: z.string().default('updatedAt'),
    order: z.string().default('desc'),
})

export const energySourcingContractsSearchSchema = z
    .object({
        page: z.coerce.number().default(1),
        recordsPerPage: z.coerce.number().default(10),
        sortBy: z.string().default('lastUpdate'),
        order: z.string().default('desc'),
    })
    .partial()

export const invoiceBillsSearchSchema = z.object({
    page: z.coerce.number().default(1),
    recordsPerPage: z.coerce.number().default(10),
    sortBy: z.string().default('endDate'),
    order: z.string().default('desc'),
})

export const reportDetailSearchSchema = payablesSummarySearchSchema.partial()
export const reportEditSearchSchema = payablesSummarySearchSchema.partial()

export const dashboardSearchSchema = z.object({
    downloadExportId: z.string().optional(),
})
